export default {
    share: {
        copySuccess: 'コピーされました'
    }
};


